function changeCard() {
  const cards = document.querySelectorAll('.js-card');
  const desktopImages = document.querySelectorAll('.l-journey__type-right .c-journey__image');

  if (!cards.length) return;

  function activateTab(index) {
    cards.forEach((card, i) => {
      card.classList.toggle('active', i === index);

      const mobileImage = card.querySelector('.c-journey__image-mobile');
      if (mobileImage) {
        mobileImage.classList.toggle('active', i === index);
      }
    });

    desktopImages.forEach((img, i) => {
      img.classList.toggle('active', i === index);
    });
  }

  cards.forEach((card, index) => {
    card.addEventListener('click', () => {
      activateTab(index);
    });
  });

  activateTab(0);
}

document.addEventListener('DOMContentLoaded', () => changeCard());

if (window.acf?.addAction) {
  const rerender = ($el) => changeCard($el[0] || $el);

  window.acf.addAction('render_block_preview', rerender);
  window.acf.addAction('render_block_preview_complete', rerender);
}
